// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-J":"J_power-ocean-collection-J__AD2an"};